import { UPDATE_CUSTOMER_DATA, UPDATE_CUSTOMER_DATA_SUCCESS, UPDATE_CUSTOMER_DATA_ERROR, UPDATE_CUSTOMER_DATA_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateCustomer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CUSTOMER_DATA:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_CUSTOMER_DATA_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_CUSTOMER_DATA_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case UPDATE_CUSTOMER_DATA_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateCustomer;
